import React from "react";

const LightNews = ({ ...rest }) => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M6.66634 12.2723V13.8333C6.66634 14.5696 7.2633 15.1666 7.99967 15.1666C8.73605 15.1666 9.33301 14.5696 9.33301 13.8333V12.2723M7.99967 1.83325V2.49992M1.99967 8.49992H1.33301M3.66634 4.16659L3.26628 3.76652M12.333 4.16659L12.7332 3.76652M14.6663 8.49992H13.9997M11.9997 8.49992C11.9997 10.7091 10.2088 12.4999 7.99967 12.4999C5.79054 12.4999 3.99967 10.7091 3.99967 8.49992C3.99967 6.29078 5.79054 4.49992 7.99967 4.49992C10.2088 4.49992 11.9997 6.29078 11.9997 8.49992Z"
                stroke="#0F1016"
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LightNews;
